import React from "react";
import { stepTwoData } from "./stepData";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  tableCellClasses,
  styled,
  useMediaQuery,
} from "@mui/material";

const StepTwo = () => {
  const isSmallScreen = useMediaQuery("(max-width:576px)");

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: isSmallScreen ? 12 : 14,
    },
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  // Styling Table Cell
  const tableHeadingsStyle = {
    xs: "13px",
    sm: "16px",
  };
  const tableContentStyle = {
    md: "14px",
    lg: "16px",
  };

  return (
    <>
      <div id="step_two_data">
        <div className=" mt-3 d-flex flex-column gap-3">
          <Typography
            sx={{
              fontSize: "23.8532px",
              lineHeight: "24px",
              textAlign: "start",
              fontFamily: "'Archivo', sans-serif",
              color: "#1F1F1F",
              fontWeight: 700,
            }}
          >
            {stepTwoData[0].heading}
          </Typography>

          <div className="d-flex flex-column gap-2">
            <ul
              style={{
                listStyle: "disc",
                fontSize: 16,
                lineHeight: "24px",
                letterSpacing: "0.08px",
                margin: 0,
                fontWeight: 500,
                fontFamily: "'Archivo',sans-serif",
              }}
            >
              {stepTwoData[0].subOneList &&
                stepTwoData[0].subOneList.map((item, index) => (
                  <li className="list m-0 pb-1" key={index}>
                    <strong> {item.head}</strong>
                    {item.text}
                  </li>
                ))}
            </ul>

            <Typography
              sx={{
                fontSize: 16,
                lineHeight: "24px",
                letterSpacing: "0.08px",
                margin: 0,
                fontWeight: 500,
                fontFamily: "'Archivo',sans-serif",
              }}
              dangerouslySetInnerHTML={{ __html: stepTwoData[0].paraOne }}
            />

            <TableContainer component={Paper} className="mt-3">
              <Table>
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: "#e7e4f9",
                    }}
                  >
                    {stepTwoData[0].tableContent.heading &&
                      stepTwoData[0].tableContent.heading.map((item, index) => (
                        <TableCell
                          key={index}
                          sx={{
                            fontSize: tableHeadingsStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            borderRight: "1px solid #c7c7c7",
                            verticalAlign: "top",
                            padding: isSmallScreen ? "16px 8px" : "16px",
                          }}
                          className="archivo"
                        >
                          {item.head}
                        </TableCell>
                      ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stepTwoData[0].tableContent.row &&
                    stepTwoData[0].tableContent.row.map((item, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell
                          sx={{
                            fontSize: tableContentStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            borderRight: "1px solid #E0E0E0",
                            padding: isSmallScreen ? "16px 8px" : "16px",
                          }}
                        >
                          {item.amount}
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            fontSize: tableContentStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            borderRight: "1px solid #E0E0E0",
                            padding: isSmallScreen ? "16px 8px" : "16px",
                          }}
                        >
                          {item.interest}
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            fontSize: tableContentStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            borderRight: "1px solid #E0E0E0",
                            padding: isSmallScreen ? "16px 8px" : "16px",
                          }}
                        >
                          {item.tenure}
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            fontSize: tableContentStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            borderRight: "1px solid #E0E0E0",
                            padding: isSmallScreen ? "16px 8px" : "16px",
                          }}
                        >
                          {item.emi}
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            fontSize: tableContentStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            borderRight: "1px solid #E0E0E0",
                            padding: isSmallScreen ? "16px 8px" : "16px",
                          }}
                        >
                          {item.tInterest}
                        </StyledTableCell>
                        <StyledTableCell
                          sx={{
                            fontSize: tableContentStyle,
                            fontFamily: "'Archivo', sans-serif",
                            color: "#1F1F1F",
                            padding: isSmallScreen ? "16px 8px" : "16px",
                          }}
                        >
                          {item.payment}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <div className="tips my-4 ">
              <div id="border_line"></div>
              <div id="tip__container" className="px-2 px-sm-4 py-4">
                <div className="px-3 py-2">
                  <div className="d-flex flex-row gap-2 align-items-center">
                    <img
                      src='/Assets/Images/tongue-out.webp'
                      alt=""
                      style={{ width: 30, height: 30 }}
                    />
                    <Typography
                      sx={{
                        fontSize: 16,
                        lineHeight: "24px",
                        letterSpacing: "0.08px",
                        color: "#59266D",
                        // color: "yellow",
                        fontFamily: "'Archivo', sans-serif",
                      }}
                    >
                      MinEmi Tip:
                    </Typography>
                  </div>
                  <div className="mt-2">
                    <Typography
                      sx={{
                        fontSize: 16,
                        lineHeight: "24px",
                        letterSpacing: "0.08px",
                        color: "#1F1F1F",
                        // color: "#f8f8f8",

                        fontFamily: "'Archivo', sans-serif",
                      }}
                    >
                      {stepTwoData[0].tip}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StepTwo;
